import apiConfig from "../config/apiConfig";
import { fetchForeignResource } from '../apis/resources';
import { fetchEnum } from '../apis/enum';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { apiFetch } from "../apis/apiFetch";


export const permaddressService = {
  async create(data: any) {
    const res = await apiFetch(apiConfig.getResourceUrl("applications"), {
      method: "POST",
      body: data.params,
    });

    const resJson = await res.json()
    console.log("resssss", resJson);
    // if (resJson.errCode === -1) alert("Error: " + resJson.message);
    return resJson
  },

  async getData() {
    const response = await apiFetch(
      `${apiConfig.getResourceUrl("applications")}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    return data.resource || [];
  },

  async getMetadata(): Promise<any> {
    const metadataUrl = apiConfig.getResourceMetaDataUrl("Permaddress");
    const res = await fetch(metadataUrl);
    if (!res.ok) throw new Error("Metadata fetch failed");
    return res.json();
  },

  async getForeignResource(name: string): Promise<any[]> {

    const data = await fetchForeignResource(name);
    return data;
  },

  async getEnum(name: string): Promise<any[]> {

    const data = await fetchEnum(name);
    return data;
  },
};
